import { clsx } from 'clsx';
import Modal from 'react-modal';
import { Global } from '@emotion/react';
import { getDialogGlobalStyles, getDialogStyles } from './DialogStyles.js';
import { useDefaultPortalRef } from '../../providers/DefaultPortalRefProvider/DefaultPortalRefProvider.js';
import { useGigerConfig } from '../../providers/useGigerConfig.js';
import { useMemo } from 'react';
import { createPortal } from 'react-dom';
import { jsxs, jsx, Fragment } from '@emotion/react/jsx-runtime';
import { useTheme } from '../../providers/GigerProvider/useTheme.js';
import { CLASS_DIALOG_BODY_OPEN } from './constants/className.js';

const Dialog = _ref => {
  var _useDefaultPortalRef;
  let {
    bodyOpenClassName = CLASS_DIALOG_BODY_OPEN,
    children,
    fullScreen = false,
    overlayClassName,
    parentSelector: parentSelectorProp,
    ...rest
  } = _ref;
  const defaultPortal = (_useDefaultPortalRef = useDefaultPortalRef()) === null || _useDefaultPortalRef === void 0 ? void 0 : _useDefaultPortalRef.current;
  const gigerConfig = useGigerConfig();
  const parentSelector = gigerConfig.emotionCacheShadowRootContainer ? () => gigerConfig.emotionCacheShadowRootContainer : parentSelectorProp !== null && parentSelectorProp !== void 0 ? parentSelectorProp : defaultPortal ? () => defaultPortal : undefined;
  const theme = useTheme();
  const dialogGlobalStyles = useMemo(() => getDialogGlobalStyles(theme), [theme]);
  const dialogStyles = useMemo(() => {
    return getDialogStyles(fullScreen);
  }, [fullScreen]);
  return jsxs(ShadowWrapper, {
    children: [jsx(Global, {
      styles: dialogGlobalStyles
    }), jsx(Modal, {
      ariaHideApp: false,
      bodyOpenClassName: bodyOpenClassName,
      css: dialogStyles,
      overlayClassName: clsx('dialog__overlay', overlayClassName),
      parentSelector: parentSelector,
      ...rest,
      children: children
    })]
  });
};
const ShadowWrapper = _ref2 => {
  let {
    children
  } = _ref2;
  const gigerConfig = useGigerConfig();
  return gigerConfig.emotionCacheShadowRootContainer ? ( /*#__PURE__*/createPortal(children, gigerConfig.emotionCacheShadowRootContainer)) : jsx(Fragment, {
    children: children
  });
};

export { Dialog };
//# sourceMappingURL=Dialog.js.map
